// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/handsontable/src/plugins/manualColumnFreeze/manualColumnFreeze.css
// module id = 503
// module chunks = 0